<script setup></script>
<template>
  <h1>Failed</h1>
</template>
<style scoped></style>
